export default "__VITE_ASSET__CP4BGURk__"